import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, Button, Card, Row, Col } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';
import MaskedInput from 'react-text-mask';
import { FaSearch, FaPlus, FaMinus } from 'react-icons/fa';
import { Formik, Field } from 'formik';
import { getToday } from '~/Utils/Helpers';
import AuthStorage from '~/Utils/AuthStorage';
import * as constants from '~/constant';
import { getAtualizarCidades } from '~/Store/Prospecto/actions';
import SelectGerenteCorretor from '~/Components/GerentesCorretores/SelectGerenteCorretor';

import DateMask from '../../DateMask';
import Select, { components } from 'react-select';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';

class FiltrosInadimplencia extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      btnMaisFiltros: false,
    };
  }

  habilitarEDesabilitarMaisFiltros = () => {
    this.setState(prevState => ({
      btnMaisFiltros: !prevState.btnMaisFiltros,
    }));
    sessionStorage.setItem(
      'filtrosInadimplenciaExpanded',
      !this.state.btnMaisFiltros
    );
  };

  saveFiltersToSession = values => {
    const filters = {
      data_inicial: values.data_inicial,
      data_final: values.data_final,
      nome_cliente: values.nome_cliente,
      cpf_cin: values.cpf_cin,
      dias_atraso: values.dias_atraso,
      data_inicial_ultimo_contato: values.data_inicial_ultimo_contato,
      data_final_ultimo_contato: values.data_final_ultimo_contato,
      codigo_familia: values.codigo_familia,
      codigo_cidade: values.codigo_cidade,
      codigo_corretor: values.codigo_corretor,
      codigo_gerente: values.codigo_gerente,
    };

    sessionStorage.setItem('inadimplencia_filtros', JSON.stringify(filters));
  };

  componentDidMount() {
    const btnMaisFiltrosState = sessionStorage.getItem(
      'inadimplencia_btnMaisFiltros'
    );
    if (btnMaisFiltrosState !== null) {
      this.setState({ btnMaisFiltros: JSON.parse(btnMaisFiltrosState) });
    }

    const savedFilters = sessionStorage.getItem('inadimplencia_filtros');
    if (savedFilters) {
      const filters = JSON.parse(savedFilters);
      this.setState({
        data_inicial: filters.data_inicial || '',
        data_final: filters.data_final || '',
        nome: filters.nome || '',
        cpf: filters.cpf || '',
        dias_atraso: filters.dias_atraso || '',
        data_ultimo_contato: filters.data_ultimo_contato || '',
        empreendimento: filters.empreendimento || null,
        imobiliaria: filters.imobiliaria || null,
        corretor: filters.corretor || null,
        gerente: filters.gerente || null,
      });
    }
  }

  filtroCidades = string => {
    return this.props.cidades
      .filter(cidades =>
        cidades.descricao.toLowerCase().includes(string.toLowerCase())
      )
      .map(item => ({
        value: item.codigo,
        label: item.descricao,
      }));
  };

  timeout = null;
  carregarCidades = (inputValue, callback) => {
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      callback(this.filtroCidades(inputValue));
    }, 500);
  };

  buildValueEmpreendimento = codigo => {
    return codigo
      ? {
          value: parseInt(codigo),
          label: this.props.empreendimentos.byId[codigo].descricao,
        }
      : { value: '', label: 'Todos empreendimentos' };
  };
  render() {
    const {
      empreendimentos,
      isLoadingOptions,
      cidades,
      cidadesById,
      getAtualizarCidades,
      onSubmit,
    } = this.props;

    const optionsEmpreendimentos = [
      { value: '', label: 'Todos empreendimentos' },
      ...empreendimentos.sort.map(item => ({
        value: item.codigo,
        label: item.descricao,
      })),
    ];

    const isCor = AuthStorage.isCorretor();

    return (
      <Formik
        onSubmit={values => {
          this.saveFiltersToSession(values);
          onSubmit(values);
        }}
        initialValues={{
          data_inicial: isCor ? '' : getToday().add(-90, 'days'),
          data_final: isCor ? '' : getToday(),
          codigo_gerente: '',
          codigo_corretor: '',
          codigo_cidade: '',
          codigo_familia: '',
          dias_atraso: '',
          cpf_cin: '',
          nome_cliente: '',
          data_inicial_ultimo_contato: '',
          data_final_ultimo_contato: '',
        }}
      >
        {({
          handleSubmit,
          values,
          handleChange,
          setFieldValue,
          errors,
          touched,
        }) => (
          <div className="CardProdutividadeFiltro">
            <Card>
              <Card.Body>
                <form onSubmit={handleSubmit}>
                  <Row className="align-items-end">
                    <Col xs="12" md="4">
                      <Form.Label>Data Pré-venda</Form.Label>
                      <Row className="align-items-center">
                        <Col xs="5" className="pe-1">
                          <DateMask
                            initialValue={values.data_inicial}
                            allowEmpty
                            onValidate={value =>
                              setFieldValue('data_inicial', value)
                            }
                          >
                            {({ dateError, dateValue, setDate }) => (
                              <Form.Group controlId="produtividade.data_inicial">
                                <MaskedInput
                                  name="data_inicial"
                                  type="tel"
                                  required={false}
                                  guide={false}
                                  className={`form-control ${((errors.data_inicial &&
                                    touched.data_inicial) ||
                                    dateError) &&
                                    'is-invalid'}`}
                                  placeholder="10/05/2025"
                                  mask={constants.MASK_DATE}
                                  value={dateValue}
                                  onChange={e => setDate(e.target.value)}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.data_inicial}
                                </Form.Control.Feedback>
                                <Form.Control.Feedback type="invalid">
                                  {dateError}
                                </Form.Control.Feedback>
                              </Form.Group>
                            )}
                          </DateMask>
                        </Col>
                        <Col xs="2" className="text-center px-0">
                          <span style={{ fontSize: '1.1rem' }}>a</span>
                        </Col>
                        <Col xs="5" className="ps-1">
                          <DateMask
                            initialValue={values.data_final}
                            allowEmpty
                            onValidate={value =>
                              setFieldValue('data_final', value)
                            }
                          >
                            {({ dateError, dateValue, setDate }) => (
                              <Form.Group controlId="produtividade.data_final">
                                <MaskedInput
                                  name="data_final"
                                  type="tel"
                                  required={false}
                                  guide={false}
                                  className={`form-control ${((errors.data_final &&
                                    touched.data_final) ||
                                    dateError) &&
                                    'is-invalid'}`}
                                  placeholder="10/05/2025"
                                  mask={constants.MASK_DATE}
                                  value={dateValue}
                                  onChange={e => setDate(e.target.value)}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.data_final}
                                </Form.Control.Feedback>
                                <Form.Control.Feedback type="invalid">
                                  {dateError}
                                </Form.Control.Feedback>
                              </Form.Group>
                            )}
                          </DateMask>
                        </Col>
                      </Row>
                    </Col>
                    <Col xs="12" md="8">
                      <SelectGerenteCorretor
                        gerente={values.codigo_gerente}
                        corretor={values.codigo_corretor}
                        onChangeCorretor={corretor =>
                          setFieldValue('codigo_corretor', corretor)
                        }
                        onChangeGerente={gerente =>
                          setFieldValue('codigo_gerente', gerente)
                        }
                        ColSizeMd={6}
                        showLabels
                        mostrarParaCorretor
                      />
                    </Col>
                  </Row>
                  <Row className="align-items-end">
                    <Col xs="12" md="3">
                      <Form.Group controlId="search.estado">
                        <Form.Label>Estado</Form.Label>
                        <Select
                          placeholder="Estado"
                          options={[
                            { value: '', label: 'Estado' },
                            ...constants.ESTADOS.map(item => ({
                              value: item.value,
                              label: item.label,
                            })),
                          ]}
                          onChange={selectedOption => {
                            const value = selectedOption
                              ? selectedOption.value
                              : '';
                            getAtualizarCidades(value);
                            setFieldValue('estado', value);
                            setFieldValue('codigo_cidade', '');
                          }}
                          value={
                            constants.ESTADOS.find(
                              item => item.value === values.estado
                            )
                              ? {
                                  value: values.estado,
                                  label: constants.ESTADOS.find(
                                    item => item.value === values.estado
                                  ).label,
                                }
                              : { value: '', label: 'Estado' }
                          }
                          styles={customStyles}
                          components={{
                            DropdownIndicator,
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col xs="12" md="4">
                      <Form.Group controlId="search.codigo_cidade">
                        <Form.Label>Cidade</Form.Label>
                        <AsyncSelect
                          isDisabled={cidades && cidades.length === 0}
                          isLoading={cidades.length === 0}
                          loadingMessage={() => 'Carregando...'}
                          noOptionsMessage={() =>
                            'Digite uma cidade. Ex.: Rio Preto'
                          }
                          placeholder="Pesquisar cidades..."
                          loadOptions={this.carregarCidades}
                          onChange={option => {
                            setFieldValue('codigo_cidade', option.value);
                          }}
                          value={
                            values.codigo_cidade &&
                            cidades.length > 0 &&
                            cidadesById[values.codigo_cidade]
                              ? {
                                  value: parseInt(
                                    cidadesById[values.codigo_cidade].codigo
                                  ),
                                  label:
                                    cidadesById[values.codigo_cidade].descricao,
                                }
                              : {
                                  value: '',
                                  label:
                                    cidades.length === 0
                                      ? 'Selecione um Estado'
                                      : 'Selecione uma cidade',
                                }
                          }
                          styles={customStyles}
                          components={{
                            DropdownIndicator,
                          }}
                        />
                        {errors.codigo_cidade && (
                          <small className="form-text text-danger">
                            {errors.codigo_cidade}
                          </small>
                        )}
                      </Form.Group>
                    </Col>
                    <Col xs="12" md="5">
                      <Form.Group controlId="search.codigo_familia">
                        <Form.Label>Empreendimento</Form.Label>
                        <Select
                          noOptionsMessage={() =>
                            'Nenhum empreendimentos encontrado'
                          }
                          placeholder="Pesquisar empreendimentos..."
                          options={optionsEmpreendimentos}
                          onChange={({ value }) =>
                            setFieldValue('codigo_familia', value)
                          }
                          isLoading={isLoadingOptions}
                          value={this.buildValueEmpreendimento(
                            values.codigo_familia
                          )}
                          styles={customStyles}
                          components={{
                            DropdownIndicator,
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  {this.state.btnMaisFiltros && (
                    <Row className="align-items-end">
                      <Col xs="12" md="4">
                        <Form.Label>Data Último Contato</Form.Label>
                        <Row className="align-items-center">
                          <Col xs="5" className="pe-1">
                            <DateMask
                              initialValue={values.data_inicial_ultimo_contato}
                              allowEmpty
                              onValidate={value =>
                                setFieldValue(
                                  'data_inicial_ultimo_contato',
                                  value
                                )
                              }
                            >
                              {({ dateError, dateValue, setDate }) => (
                                <Form.Group controlId="produtividade.data_inicial_ultimo_contato">
                                  <MaskedInput
                                    name="data_inicial_ultimo_contato"
                                    type="tel"
                                    required={false}
                                    guide={false}
                                    className={`form-control ${((errors.data_inicial_ultimo_contato &&
                                      touched.data_inicial_ultimo_contato) ||
                                      dateError) &&
                                      'is-invalid'}`}
                                    placeholder="Ex.: 01/01/2019"
                                    mask={constants.MASK_DATE}
                                    value={dateValue}
                                    onChange={e => setDate(e.target.value)}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {errors.data_inicial_ultimo_contato}
                                  </Form.Control.Feedback>
                                  <Form.Control.Feedback type="invalid">
                                    {dateError}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              )}
                            </DateMask>
                          </Col>
                          <Col xs="2" className="text-center px-0">
                            <span style={{ fontSize: '1.1rem' }}>a</span>
                          </Col>
                          <Col xs="5" className="ps-1">
                            <DateMask
                              initialValue={values.data_final_ultimo_contato}
                              allowEmpty
                              onValidate={value =>
                                setFieldValue(
                                  'data_final_ultimo_contato',
                                  value
                                )
                              }
                            >
                              {({ dateError, dateValue, setDate }) => (
                                <Form.Group controlId="produtividade.data_final_ultimo_contato">
                                  <MaskedInput
                                    name="data_final_ultimo_contato"
                                    type="tel"
                                    required={false}
                                    guide={false}
                                    className={`form-control ${((errors.data_final_ultimo_contato &&
                                      touched.data_final_ultimo_contato) ||
                                      dateError) &&
                                      'is-invalid'}`}
                                    placeholder="Ex.: 01/01/2019"
                                    mask={constants.MASK_DATE}
                                    value={dateValue}
                                    onChange={e => setDate(e.target.value)}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {errors.data_final_ultimo_contato}
                                  </Form.Control.Feedback>
                                  <Form.Control.Feedback type="invalid">
                                    {dateError}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              )}
                            </DateMask>
                          </Col>
                        </Row>
                      </Col>
                      <Col xs="12" md="2">
                        <Form.Label>Dias de Atraso</Form.Label>
                        <Form.Group controlId="produtividade.dias_atraso">
                          <Form.Control
                            name="dias_atraso"
                            type="number"
                            min="0"
                            placeholder="Ex: 30"
                            value={values.dias_atraso}
                            onChange={handleChange}
                            className={`form-control ${errors.dias_atraso &&
                              touched.dias_atraso &&
                              'is-invalid'}`}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.dias_atraso}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="3">
                        <Form.Label>Nome Cliente</Form.Label>
                        <Form.Group controlId="produtividade.nome_cliente">
                          <Form.Control
                            name="nome_cliente"
                            type="text"
                            placeholder="Digite o nome"
                            value={values.nome_cliente}
                            onChange={handleChange}
                            className={`form-control ${errors.nome_cliente &&
                              touched.nome_cliente &&
                              'is-invalid'}`}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.nome_cliente}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="3">
                        <Form.Label>CPF/CIN</Form.Label>
                        <Form.Group controlId="produtividade.cpf_cin">
                          <MaskedInput
                            name="cpf_cin"
                            type="tel"
                            required={false}
                            guide={false}
                            className={`form-control ${errors.cpf_cin &&
                              touched.cpf_cin &&
                              'is-invalid'}`}
                            placeholder="000.000.000-00"
                            mask={constants.MASK_CPF}
                            value={values.cpf_cin}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.cpf_cin}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  )}
                  <Row className="justify-content-end">
                    <Col xs="12" lg="auto" className="text-right">
                      <Form.Group>
                        <Button
                          variant="outline-primary"
                          className="ml-2"
                          onClick={() => {
                            this.habilitarEDesabilitarMaisFiltros();
                          }}
                        >
                          {this.state.btnMaisFiltros ? (
                            <>
                              <FaMinus />
                              <span className="d-xs-none">&nbsp; Filtros</span>
                            </>
                          ) : (
                            <>
                              <FaPlus />
                              <span className="d-xs-none">&nbsp; Filtros</span>
                            </>
                          )}
                        </Button>
                        <Button
                          variant="outline-primary"
                          type="submit"
                          className="ml-2"
                        >
                          <FaSearch />
                          <span>&nbsp;Buscar</span>
                        </Button>
                      </Form.Group>
                    </Col>
                  </Row>
                </form>
              </Card.Body>
            </Card>
          </div>
        )}
      </Formik>
    );
  }
}

const mapStateToProps = state => ({
  empreendimentos: state.empreendimentos,
  imobiliarias: state.corretor.listaGerentes,
  isLoadingOptions: state.prospecto.isLoadingOptions,
  cidades: state.options.cidades,
  cidadesById: state.options.cidadesById,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getAtualizarCidades }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FiltrosInadimplencia);
